import { TagChip } from '@cognite/cogs-core';
import type { DoubleDatapoint } from '@cognite/sdk';
import dayjs from 'dayjs';

interface Props {
  latestDatapoint: DoubleDatapoint;
  unit?: string;
}

export const LatestNumericReadingPreview = ({
  latestDatapoint,
  unit,
}: Props) => {
  const latestValue = latestDatapoint.value;

  const dateDiff = dayjs().diff(dayjs(latestDatapoint?.timestamp));
  const duration = dayjs.duration(dateDiff);

  const formattedDate = (() => {
    if (duration.days() > 0) {
      return `${duration.days()}d`;
    }
    if (duration.hours() > 0) {
      return `${duration.hours()}h`;
    }
    return `${duration.minutes()}m`;
  })();

  const description = `${formattedDate} ago`;
  const tagLabel = `${description} | ${latestValue} ${unit ?? ''}`;
  const renderChip = latestValue != undefined && latestValue !== null;

  return (
    renderChip && (
      <TagChip
        size="small"
        label={tagLabel}
        data-testid="latest-numeric-reading-preview"
      />
    )
  );
};
